import React from 'react'
import PropTypes from 'prop-types'
// import R from 'ramda'

import BaseCheckboxField from './baseCheckbox'

const SessionRenewableField = ({
  name,
  width,
  onChange,
  renewable
}) => (
  <BaseCheckboxField
    name = {name}
    width = {width}
    onChange = {onChange}
    labelTxt = 'Renewable'
    popupTxt='If checked, the user will not have to sign in again when their session expires in Max. (can be good or bad)'
    checked={renewable}
  />
)

SessionRenewableField.propTypes = {
  name: PropTypes.string.isRequired,
  width: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  renewable: PropTypes.bool.isRequired
}

export default SessionRenewableField



// WEBPACK FOOTER //
// ./webAdmin/forms/sessionRenewableField.js